import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/PhysicalSecurity/ai-ptz-precision@2x.jpg";
import v3Image from "../../assets/PTZ/ai-ptz-precision.jpg";
import type { Product } from "../../types";
import { ptz } from "../product-groups/cameraSecurity/Ptz";
import { ptz as productListGroupPTZ } from "../product-list-groups/ptz";

export const aiPtzPrecision: Product = {
  id: "aiPtzPrecision",
  productTitle: "AI PTZ Precision",
  description: "aiPtzPrecision.description",
  isNew: true,
  isComingSoon: true,
  comingSoonButtonText: "aiPtzPrecision.comingSoonButtonText",
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-ai-ptz-precision`],
  storePathParts: {
    productSlug: "uvc-ai-ptz-precision",
    category: "cameras-ptz",
  },
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 200,
    height: 182,
  },
  productGroup: ptz,
  productListGroup: productListGroupPTZ,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          'Without mount:\nØ241 x 349 mm (Ø9.5 x 13.7")\nWith mount:\n372 x 241 x 299 mm (14.7 x 9.5 x 11.8")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.8" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "aiPtzPrecision.fov",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "100 m (328 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: {
        type: "translation",
        value: "aiPtzPrecision.opticalZoom",
      },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "outdoorReady",
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "deployment",
      value: { type: "string", value: "PoE++" },
    },
  ],
};
